import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Menu from './Menu';
import Header from './Header';
import Megamenu from './Megamenu';
import Routes from '../Route';
import './layout.css';

export default class Layout extends Component {
	render() {
		return (
			<>
				<div id="wrapper">
					<Header />
					<Menu {...this.props} />
					<div id="main-content">
						<Switch>
							{Routes.map((layout, i) => {
								return <Route key={`r${i}`} exact={layout.exact} path={layout.path} component={layout.component}></Route>
							})}
							<Route path="*">
								<Redirect to="/notfound" />
							</Route>
						</Switch>
					</div>
				</div>
				<ToastContainer
					position="bottom-right"
					autoClose={4000}
					hideProgressBar={false}
					newestOnTop
					closeOnClick
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
			</>
		);
	}
}
